import React from 'react';
import { Route, IndexRoute, Redirect } from 'react-router';
import Loadable from 'react-loadable';
import LoadingComponent from 'components/LoadingComponent';
import { observer, inject } from 'mobx-react';
import getIEVerison from 'utils/getIEVersion';
import { Tracker } from '@ali/react-util';
const { setSPM } = Tracker;
@inject('dashboardStore')
@observer
class App extends React.Component {
  state = {
    showTip: getIEVerison() > 0 && getIEVerison() <= 10,
  };

  async componentDidMount() {
    await this.props.dashboardStore.fetchHomeText12();
    this.props.dashboardStore.init();
  }

  close = () => {
    this.setState({ showTip: false });
  };

  render() {
    if (this.props.dashboardStore.loading) {
      return null;
    }
    const { showTip } = this.state;
    return (
      <div className={showTip && 'showTip'}>
        <div className="browser-tip">
          <div className="content">
            为了获得最好的用户体验，请更新至最新的&nbsp;
            <a href="https://www.google.cn/intl/zh-CN/chrome/?spm=0.0.0.0.BlJdkH">Chrome 浏览器</a>
            <div className="close" onClick={this.close}>
              X
            </div>
          </div>
        </div>
        {this.props.children}
      </div>
    );
  }
}

const query = window.$ACE.URL.getSearch();

let AppWithSPM = setSPM('5176', '12365691')(App);
if (query.params) {
  AppWithSPM = setSPM('5176', '12365691-share')(App);
}

const getLoadableComponent = (name, platform) => {
  return Loadable({
    loader: () => import(`pages/1212/${name}/${platform}`),
    loading: LoadingComponent,
  });
};

const getComponents = platform => {
  return (
    <Route path="/" component={AppWithSPM}>
      <IndexRoute component={getLoadableComponent('Home', platform)} />
      <Redirect from="*" to="/" />
    </Route>
  );
};
export default () => {
  if (window.innerWidth <= 768) {
    return getComponents('h5');
  } else {
    return getComponents('pc');
  }
};



// WEBPACK FOOTER //
// ./src/scripts/pages/1212/index.js